import React from "react";
import { FaCalendar, FaMapMarkerAlt, FaUser, FaEnvelope, FaPhone, FaDownload } from "react-icons/fa";

const TicketCard = ({
  ticket,
  barcodeUrl,
  qrCodeUrl,
  formatDate,
  formatPrice,
  onDownload,
  generatingTicket,
}) => {
  if (!ticket) return null;

  const attendeeName = `${ticket?.delegate?.name || ""} ${
    ticket?.delegate?.surname || ""
  }`.trim() || "Guest Attendee";

  return (
    <div id="ticket-container" className="ticket-view-card">
      <div className="ticket-view-card__header">
        <div className="ticket-view-card__header-shape--top" />
        <div className="ticket-view-card__header-shape--bottom" />

        <div className="ticket-view-card__header-content">
          <div className="ticket-view-card__header-row">
            <div className="ticket-view-card__header-left">
              <h1 className="ticket-view-card__event-title">{ticket.eventName}</h1>
              <div className="ticket-view-card__event-subrow">
                <div className="ticket-view-card__ticket-type">{ticket.ticketType}</div>
                <div className="ticket-view-card__event-location">
                  <FaMapMarkerAlt />
                  <span>{ticket.eventLocation || "Location TBA"}</span>
                </div>
              </div>

              <div className="ticket-view-card__header-attendee">
                <div className="ticket-view-card__header-attendee-name">
                  <FaUser />
                  <span>{attendeeName}</span>
                </div>
                {ticket?.delegate?.email && (
                  <div className="ticket-view-card__header-attendee-line">
                    <FaEnvelope />
                    <span>{ticket.delegate.email}</span>
                  </div>
                )}
                {ticket?.delegate?.phone && (
                  <div className="ticket-view-card__header-attendee-line">
                    <FaPhone />
                    <span>{ticket.delegate.phone}</span>
                  </div>
                )}
              </div>
            </div>

            {qrCodeUrl && (
              <div className="ticket-view-card__qr-in-header">
                <img src={qrCodeUrl} alt="Ticket QR code" />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="ticket-view-card__body">
        <div className="ticket-view-card__layout">
          {/* LEFT: event summary + notice */}
          <div className="ticket-view-card__layout-left">
            <button
              type="button"
              className={`ticket-view-card__download-button${
                generatingTicket ? " ticket-view-card__download-button--disabled" : ""
              }`}
              onClick={onDownload}
              disabled={generatingTicket}
            >
              <FaDownload />
              {generatingTicket ? "Generating Ticket..." : "Download Ticket as PDF"}
            </button>

            <div className="ticket-view-card__notice">
              <div className="ticket-view-card__notice-title">Important</div>
              <div className="ticket-view-card__notice-text">
                Please arrive at the venue at least 30 minutes before the event start time.
                Have your ticket ready (either printed or on your mobile device) to ensure a smooth check-in.
              </div>
            </div>
          </div>

          {/* RIGHT: centered barcode */}
          <div className="ticket-view-card__layout-right">
            {barcodeUrl && (
              <div className="ticket-view-card__barcode-central">
                <div className="ticket-view-card__barcode-label">Barcode</div>
                <img src={barcodeUrl} alt="Ticket barcode" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketCard;
